import React, { useRef } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useThemeContext } from '../../context/ThemeContext';

const DevIndicator = () => {
  const isDevelopment = import.meta.env.MODE === 'development';
  const { darkTheme, mode } = useThemeContext();
  const audioRef = useRef(null);

  // Only show in development mode with Darkwing theme
  if (!isDevelopment || darkTheme !== 'darkwing' || mode !== 'dark') {
    return null;
  }

  const handleClick = () => {
    // Play only the last 3 seconds of the audio
    if (audioRef.current) {
      const audio = audioRef.current;
      
      // Wait for metadata to load to get duration
      if (audio.duration) {
        // Set currentTime to 3 seconds before the end
        audio.currentTime = Math.max(0, audio.duration - 2.8);
        audio.play().catch(err => {
          console.log('Audio playback failed:', err);
        });
      } else {
        // If duration not loaded yet, wait for it
        audio.addEventListener('loadedmetadata', () => {
          audio.currentTime = Math.max(0, audio.duration - 2.8);
          audio.play().catch(err => {
            console.log('Audio playback failed:', err);
          });
        }, { once: true });
      }
    }
  };

  return (
    <>
      {/* Hidden audio element - add your own audio file in /public folder */}
          <audio ref={audioRef} src="/darkwing-duck-short.mp3" preload="auto" />
      
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 9999,
        }}
      >
        <Chip
          onClick={handleClick}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ fontSize: '1.2rem' }}>🦆</span>
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                Let's Get Dangerous!
              </Typography>
            </Box>
          }
          sx={{
            background: 'linear-gradient(45deg, #9d4edd 30%, #ff006e 90%)',
            color: 'white',
            fontWeight: 'bold',
            boxShadow: '0 3px 5px 2px rgba(157, 78, 221, .3)',
            animation: 'pulse 2s ease-in-out infinite',
            cursor: 'pointer',
            pointerEvents: 'all',
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0 5px 8px 3px rgba(157, 78, 221, .4)',
            },
            '&:active': {
              transform: 'scale(0.95)',
            },
            '@keyframes pulse': {
              '0%, 100%': {
                opacity: 1,
              },
              '50%': {
                opacity: 0.8,
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default DevIndicator;
